import { createSvgIcon } from '@mui/material/utils';
export default createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13 13"
        fill="currentColor"
    >
        <g id="c">
            <rect className="d" width="9" height="9" />
            <rect className="d" x="4" y="4" width="9" height="9" />
        </g>
    </svg>,
    'React'
);
